import { Sidebar, useSidebar } from '@/components/ui/sidebar';
import { useIsMobile } from '@/hooks/useMobile.hook';
import { useTheme } from 'next-themes';
import ECILogo from '@/assets/images/ECI_Logo.png';
import ECILogoLight from '@/assets/images/ECI_Logo_Light.png';

import SidebarHeaderSection from '@/components/Sidebar/SidebarHeaderSection';
import SidebarNavigation from '@/components/Sidebar/SidebarNavigation';
import SidebarUserCard from '@/components/Sidebar/SidebarUserCard';

export function AppSidebar() {
  const { state, setOpenMobile } = useSidebar();
  const isCollapsed = state === 'collapsed';
  const isMobile = useIsMobile();
  const { resolvedTheme } = useTheme();
  const sidebarLogo = !isMobile ? ECILogo : resolvedTheme === 'dark' ? ECILogo : ECILogoLight;

  return (
    <Sidebar collapsible="icon" className="bg-[#091327]">
      <SidebarHeaderSection
        isCollapsed={isCollapsed}
        logo={sidebarLogo}
        onCloseMobile={() => setOpenMobile(false)}
      />

      <SidebarNavigation isCollapsed={isCollapsed} onItemClick={() => setOpenMobile(false)} />
      <SidebarUserCard />
    </Sidebar>
  );
}
